// Set REACT_APP_CLIENT in .env.development.local to point to the UAT Vercel deployment
// (e.g. https://fla-associate-uat.nautes.eu) to avoid hitting the production deployment
// which has Vercel Deployment Protection enabled and returns 403.
export const API_BASE =
  process.env.REACT_APP_CLIENT || 'https://areariservata.fla-plus.it';
export const AUTH_ROOT = API_BASE + '/api/auth';
export const REFRESH_TOKEN = AUTH_ROOT + '/refreshToken';
export const LOGIN = AUTH_ROOT + '/login';
export const SSO_LOGIN = AUTH_ROOT + '/ssoLogin';
export const RECOVERY_TOKEN_DRUPAL = AUTH_ROOT + '/recoveryDrupalToken';
export const REGISTER_CHECK = AUTH_ROOT + '/registerCheck';
export const REGISTER_DRUPAL = AUTH_ROOT + '/register';
export const UPDATE_USER_DRUPAL = AUTH_ROOT + '/updateUser';
export const UPDATE_INTERESTS_DRUPAL = AUTH_ROOT + '/updateInterests';
export const LIST_USERS_DRUPAL = AUTH_ROOT + '/listUsers';
export const LIST_SURVEYS_DRUPAL = AUTH_ROOT + '/listSurveys';
// export const GET_MENU = API_BASE + '/api/menu';
export const DRUPAL_BASE = process.env.REACT_APP_HOST;
export const OAUTH_USER_INFO = DRUPAL_BASE + '/oauth/userinfo';
export const EMAIL_CHECK_DRUPAL = AUTH_ROOT + '/emailCheck';
export const CHECK_SESSION = AUTH_ROOT + '/checkSession';
export const LOGOUT_DRUPAL = AUTH_ROOT + '/logout';
// Password Recovery Routes
export const RESET_PASSWORD_DRUPAL =
  AUTH_ROOT + '/passwordRecovery/passwordReset';
export const UPDATE_PASSWORD_DRUPAL =
  AUTH_ROOT + '/passwordRecovery/passwordUpdate';
